import {
  Box,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  TableBody,
} from "@mui/material";
import { useState } from "react";

const PriceCalculator = () => {
  const [inputTokens, setInputTokens] = useState(300);
  const [outputTokens, setOutputTokens] = useState(150);
  const inputCost = (inputTokens / 1000) * 0.0015;
  const outputCost = (outputTokens / 1000) * 0.002;
  const totalCost = inputCost + outputCost;

  const roundValue = (value) => {
    if (value) {
      return value.toFixed(5);
    }
  };

  return (
    <Box py={2}>
      <Typography variant="h8" mb={1.5}>
        GPT 3.5 Turbo Pricing
      </Typography>
      <ul>
        <li>
          <Typography variant="body10">Input: $0.0015 per 1k tokens</Typography>
        </li>
        <li>
          <Typography variant="body10">Output: $0.002 per 1k tokens</Typography>
        </li>
        <li>
          <Typography variant="body10">Maximum Tokens used: 4096</Typography>
        </li>
      </ul>
      <Box>
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{ maxHeight: 400 }}
        >
          <Table size="small" aria-label="a dense table" stickyHeader>
            <TableHead>
              <TableRow sx={{ background: "#e5e5e5" }}>
                <TableCell align="left" sx={{ width: "15%" }}>
                  <Typography variant="body8">Type</Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: "12%" }}>
                  <Typography variant="body8">Input Tokens</Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: "12%" }}>
                  <Typography variant="body8">Output Tokens</Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: "15%" }}>
                  <Typography variant="body8">Total Tokens</Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: "15%" }}>
                  <Typography variant="body8">Cost (Input)</Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: "15%" }}>
                  <Typography variant="body8">Cost (Output)</Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: "20%" }}>
                  <Typography variant="body8">Total Cost</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell align="left">
                  <Typography variant="body10">Average Usage</Typography>
                </TableCell>
                <TableCell align="left">
                  <TextField
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    type="number"
                    InputProps={{
                      style: {
                        fontSize: "15px",
                        fontFamily: "Poppins",
                      },
                    }}
                    value={inputTokens}
                    onChange={(e) => {
                      let value = e.target.value;
                      setInputTokens(e.target.value ? parseInt(value, 10) : "");
                    }}
                  />
                </TableCell>
                <TableCell align="left">
                  <TextField
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    value={outputTokens}
                    type="number"
                    InputProps={{
                      style: {
                        fontSize: "15px",
                        fontFamily: "Poppins",
                      },
                    }}
                    onChange={(e) => {
                      let value = e.target.value;
                      setOutputTokens(value ? parseInt(value, 10) : "");
                    }}
                  />
                </TableCell>
                <TableCell align="left">
                  <Typography variant="body10">
                    {inputTokens + outputTokens}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography variant="body10">
                    ${roundValue(inputCost)}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography variant="body10">
                    ${roundValue(outputCost)}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography variant="body10">
                    ${roundValue(totalCost)}(Rs. {roundValue(totalCost * 86)})
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default PriceCalculator;
